<template>
    <!-- <AdminLayout> -->
        <section class="flex items-start">
            <div class="w-full">
                <div class="mt-12">
                    <div class="border rounded-lg py-4 px-5">
                        <div class="flex justify-between mb-8"><p class="font-semibold text-xl text-neutral-800">Leave listing </p></div>
                        <div>
                            <div class="grid grid-cols-12 bg-[#ECF6FF] divide-x-[1px] divide-white rounded-md">
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold justify-center">No.</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Leave Name</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Leave Type</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Total Leave</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Effective After</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Leave Span From Date</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Leave Span To Date</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Department</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Designation</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Sandwich Leave</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold">Leave Duration</div>
                                <div class="text-[11px] leading-none px-2 py-2 flex text-[#404A5A] items-center font-semibold justify-center">Action</div>
                            </div>

                                                        <!-- Skeleton Loader -->
                            <div v-if="isLoading">
                                <div class="grid grid-cols-12 bg-white divide-x-[1px] shadow mt-1.5 animate-pulse" v-for="index in 6" :key="index">
                                    <div class="px-2 py-2" v-for="index in 12" :key="index">
                                        <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                    </div>
                                </div>
                            </div>

                            <!-- loop area -->
                            <div v-else>
                            <!-- No data found -->
                            <div v-if="leaveData.length === 0" class="text-center py-4 text-neutral-500 text-sm">
                            No data found.
                            </div>
                            <div v-for="(leave, index) in leaveData" :key="index" class="grid grid-cols-12 divide-x divide-y divide-[#eaeaea]">
                                <div class="text-xs px-2 py-2 flex items-center justify-center border-t border-[#eaeaea]">{{ index + 1 }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ leave.leaveName }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ leave.paidLeave }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ leave.totalLeaves }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ leave.effectiveAfter }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ formatDate(leave.leaveSpanFromDate) }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ formatDate(leave.leaveSpanToDate) }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ leave.leaveDepartment }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ leave.leaveDesignation }}</div>
                                <div class="text-xs px-2 py-2 flex items-center">{{ leave.leaveSandwitch  }}</div>
                                <div class="text-xs px-2 py-2 flex items-center"> {{ parseLeaveDuration(leave.leaveDuration) }}</div>
                                <div class="text-xs leading-none px-2 py-2 flex items-center font-normal">
                                    <router-link :to="`/leave-details/${leave.id}`" class="inline-flex items-center justify-center w-8 h-7 bg-blue-200 text-blue-600 rounded-md">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg>
                                    </router-link>
                                    <router-link :to="`/leave-setting/${leave.id}`" class="inline-flex items-center justify-center w-8 h-7 bg-blue-200 text-blue-600 rounded-md ml-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                                        <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/>
                                    </svg>
                                    </router-link>
                                </div>
                            </div>
                            </div>
                          
                            

                        </div>

                    </div>
                </div>    
            </div>
            <!-- <RightSideBar /> -->
        </section>
    <!-- </AdminLayout> -->
</template>

<script>
// import AdminLayout from '../AdminDashboard/AdminLayout.vue';
// import RightSideBar from '../../components/RightSideBar.vue';
import { BASE_URL } from "../../config";
import axios from "axios";
import { createToast } from 'mosha-vue-toastify';
import moment from "moment";

export default {
    name: 'LeaveListing',
    components: {
        // AdminLayout,
        // RightSideBar,
    },
    data() {
        return {
            leaveData: [],
            isLoading: true, // Add loading state
            globalDateFormat: '',
        };
    },

    created() {
        this.fetchLeaveList();
        this.globalDateFormat = localStorage.getItem("globalDateFormat");
    },

    props: {
      leaves: Array, // Array of leave objects
    },

    methods: {
        async fetchLeaveList() {
            this.isLoading = true;
            try {
                const response = await axios.post(BASE_URL + '/leave-list', {
                    companyId: localStorage.getItem('company_id')
                });
                this.leaveData = response.data.leaveList;
                console.log("Leave Data:", response.data.leaveList);
            } catch (error) {
                console.error("Error fetching leave list:", error);
                this.tostMessage('danger', 'Failed to fetch leave list');
            } finally {
                this.isLoading = false;
            }
        },

        tostMessage(type, message) {
            createToast({ description: message }, {
                type,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: true
            });
        },

        parseLeaveDuration(duration) {
            try {
                return duration ? JSON.parse(duration).join(", ") : "N/A";
            } catch (e) {
                return "N/A"; // Handle invalid JSON
            }
        },

        formatDate(date) {
            if (!date) return '';
            return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
        },
    }

    
}
</script>

<style scoped>
/* Remove default input focus */
input:focus {
    outline: none;
}
</style>
